<template>
  <div class="clinic-map-sheet">
    <div class="clinic-map-sheet__top">
      <div>
        <div class="clinic-map-sheet__heading">
          <NuxtLink :to="detailUrl" class="clinic-map-sheet__name">{{ clinic.name }}</NuxtLink>
          <ClinicOwnerClaimLink v-if="clinic.hasUser === false" :clinic-id="clinic.id"/>
        </div>
        <p v-if="clinic.address" class="clinic-map-sheet__meta" v-html="sanitizeHtml(clinic.address)"/>
        <p
            v-if="clinic.schedule"
            class="clinic-map-sheet__meta"
            :class="{'clinic-map-sheet__meta--accent': clinic.isAlwaysOpen}"
            v-html="sanitizeHtml(clinicSchedulePlain(clinic.schedule))"
        />
      </div>
      <button type="button" class="clinic-map-sheet__close" aria-label="Закрыть" @click="emit('close')">
        <SvgoClose aria-hidden="true"/>
      </button>
    </div>
    <div class="clinic-map-sheet__cta" @click.stop @mousedown.stop @mouseup.stop>
      <ClinicCallButton :key="clinic.id" :clinic="clinic" source="map" classList="outline"/>
      <ClinicAppointmentButton :clinic="clinic" :serviceId="serviceId"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {TClinic} from '~/types/clinic';
import {sanitizeHtml} from '~/utils/sanitizeHtml';
import {clinicSchedulePlain} from '~/utils/clinicScheduleLabel';

const props = defineProps<{
  clinic: TClinic;
  serviceId?: number;
}>();

const emit = defineEmits<{
  close: [];
}>();

const detailUrl = computed(() =>
    props.clinic.slug ? `/clinics/${props.clinic.citySlug}/${props.clinic.slug}/` : '');
</script>
